<template>
  <div class="page-content" id="certificate-index">
    <Titlebar>
      <template v-slot:incrustation>
        <IconCertificate />
      </template>
      <h1>{{ $t('nav.certificate') }}</h1>
    </Titlebar>
    <div>
      <div class="container">
        <div v-if="isLoading" class="spinner-border text-secondary mt-3" role="status">
          <span class="sr-only">{{ $t("global.loading") }}</span>
        </div>
        <UiCard style="border-radius: 2px !important;" v-if="!isLoading">
          <div v-html="html" ></div>
        </UiCard>
      </div>
    </div>

    <Toolbar>
      <Btn @click.native.prevent="downloadReport" class="pull-right primary" :class="{disabled: isDownloadLoading}">
        <div v-if="isDownloadLoading" class="spinner-border spinner-border-sm" role="status"></div>
        {{ $t('global.download') }}
      </Btn>
    </Toolbar>
  </div>
</template>

<script>
import API from '@/services/API.js';
import axios from 'axios';
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";
import moment from "moment/moment";
import { IconCertificate } from '@/components/icons'
import Utils from '@/services/utils.js';
import {useDvFlagAccess} from "../../services/featureFlag";

export default {
  name: 'CertificateIndex',
  components: {
    IconCertificate,
    Titlebar,
    Toolbar,
    Btn,
    UiCard,
  },
  data:() => ({
    isLoading: true,
    isDownloadLoading: false,
    html: null,
    isThemeSfr: Utils.isThemeSfr(),
    isThemeCatsafe: Utils.isThemeCatsafe()
  }),
  mounted() {
    if(!useDvFlagAccess('beepiz-certificate-can:read')){
      this.$router.push({ name: 'AccessDenied', params: { slug: "certificate"} })
    }
  },
  methods: {
    loadData: function () {
      axios
        .get(API.endpoints.certificate.index,{
          headers: {
            'Accept': 'text/html'
          }
        })
        .then(response => {
          this.html = response.data;
        })
        .catch(error => {
          window.Vfc.$refs.messages.sendMessage(
            'error',
            error.response.data || window.V.$i18n.t('errors.default')
          );
        })
        .finally(() => {
          this.isLoading = false;
        })
    },
    downloadReport: function () {
      this.isDownloadLoading = true
      axios
        .get(API.endpoints.certificate.index, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/pdf'
          }
        })
        .then(response => {
          const currentDate = moment().format("DDMMYYYY");
          const filename = window.V.$i18n.t("nav.certificate", {date: currentDate});
          const newBlob = new Blob([response.data], {type: 'application/pdf'})
          const data = window.URL.createObjectURL(newBlob);
          let link = document.createElement('a');
          document.body.appendChild(link);
          link.href = data;
          link.download = filename;
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(data);
          }, 100)
        })
        .catch(error => {
          window.Vfc.$refs.messages.sendMessage(
            'error',
            error?.response?.data || window.V.$i18n.t('errors.default')
          );
        })
        .finally(() => {
          this.isDownloadLoading = false
        })
    }
  },
  created() {
    this.loadData();
  },
}
</script>
